import CustomButton from "@components/buttons/CustomButton";
import GlobalTextInputField from "@components/inputs/GlobalTextInputField";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { groupManagementApi } from "@services/apis/GroupManagement";
import {
  CreateGroupRequest,
  CreateGroupResponse,
} from "@services/models/Groups/CreateGroup";
import React, { useState } from "react";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface CreateGroupSliderProps {
  isOpen: boolean;
  onClose: () => void;
  onGroupCreated?: () => void;
}

const CreateGroupSlider: React.FC<CreateGroupSliderProps> = ({
  isOpen,
  onClose,
  onGroupCreated,
}) => {
  const [groupName, setGroupName] = useState<string>("");
  const [groupDescription, setGroupDescription] = useState<string>("");
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false);
  const { handleError, handleSuccess } = useSnackbarMessage();

  const checkValidInput = () => {
    return groupName.trim().length > 0 && groupDescription.trim().length > 0;
  };

  const handleSubmit = async () => {
    try {
      setIsButtonLoading(true);
      const createGroupRequest: CreateGroupRequest = {
        name: groupName.trim(),
        description: groupDescription.trim(),
      };
      const response: CreateGroupResponse =
        await groupManagementApi.createGroup(createGroupRequest);
      handleSuccess({ message: response.msg || "Group created successfully" });
      setGroupName("");
      setGroupDescription("");
      onGroupCreated?.();
      onClose();
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.msg ||
        "Creating group failed. Please try again.";
      handleError({ message: errorMessage });
    } finally {
      setIsButtonLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={isOpen}
      heading={"Create Group"}
      onClose={onClose}
      onClickCross={onClose}
      showConfirm={false}
    >
      <div className="flex flex-col px-[16px] py-[16px] gap-4">
        <GlobalTextInputField
          placeholder="Enter group name"
          value={groupName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setGroupName(e.target.value)
          }
          title="Enter the group name"
        />
        <GlobalTextInputField
          placeholder="Enter group description"
          value={groupDescription}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setGroupDescription(e.target.value)
          }
          title="Enter the group description"
        />
        <div className="my-4">
          <CustomButton
            text="CREATE GROUP"
            onClick={handleSubmit}
            isActive={checkValidInput()}
            isButtonLoading={isButtonLoading}
          />
        </div>
      </div>
    </SlidingPanel>
  );
};

export default CreateGroupSlider;
